import * as angular from 'angular';
import AddressDisplayBridge from './AddressDisplayBridge';

angular
  .module('flowingly.runner.directives')
  .component('addressDisplay', AddressDisplayBridge);
